import useSWR from "swr";
import { Tab } from ".";
import { customFetcher } from "../../../utils";
import { CorporateEmail } from "../../../globals/interfaces";
import VirtualTable from "../../../components/custom/VirtualTable";

export default function Logs ({
    activeTab
}: {
    activeTab: Tab
}) {

    const {
        data
    } = useSWR(activeTab === 'LOGS' ? `/corporate-email` : null, customFetcher<CorporateEmail>, {
        fallbackData: []
    })

    return (
        <VirtualTable<CorporateEmail> 
            data={data}
            mapping={[{
                name: 'Subject',
                value: 'subject'
            }, {
                name: 'Created',
                value: 'created',
                datetime: true,
                utc: true
            }, {
                name: 'Body',
                value: 'body'
            }]}
        />
    );
}